export enum KEYBOARD_EVENTS {
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  TAB = 'Tab',
  ENTER = 'Enter',
}
